import React, { useState } from "react"

import { FormProvider, useForm } from "react-hook-form"

import { PoliciesListType } from "@common-shared/config/oneVerify/oneVerifyPolicies.config"
import { IPoliciesListFiltersData } from "@common-shared/types/policies.types"

import { ButtonElement } from "@front-shared/elements/button.element"

import { POLICIES_CONFIG } from "../../../config/policies.config"
import { usePoliciesList } from "../../../hooks/policiesList.hook"
import { useAppSelector } from "../../../store/selectors/app.selector"
import { policiesSelector } from "../../../store/selectors/policies.selector"
import { PoliciesFiltersFormComponent } from "./policiesFiltersForm.component"

export const SearchFiltersComponent: React.FunctionComponent<
    ISearchFiltersComponentProps
> = props => {
    const formMethods = useForm<IPoliciesListFiltersData>()
    const { handleSubmit } = formMethods

    const { processFiltersFormData } = usePoliciesList()

    const { historyFilters } = useAppSelector(policiesSelector)

    const [isDataError, setIsDataError] = useState<boolean>(false)

    const onSubmit = (data: IPoliciesListFiltersData) => {
        setIsDataError(false)

        const mappedData = processFiltersFormData(data)

        const providedMemberData = Object.keys(mappedData)
            .filter(key =>
                POLICIES_CONFIG.searchMemberDataFilters.includes(
                    key as keyof IPoliciesListFiltersData,
                ),
            )
            .map(key => mappedData[key as keyof IPoliciesListFiltersData])
            .filter(item => !!item)

        const providedGeneralData = Object.keys(mappedData)
            .map(key => mappedData[key as keyof IPoliciesListFiltersData])
            .filter(item => !!item)

        if (
            (providedMemberData.length &&
                providedMemberData.length <
                    POLICIES_CONFIG.minMemberDataFields) ||
            providedGeneralData.length < POLICIES_CONFIG.minOverallDataFields
        ) {
            setIsDataError(true)

            return
        }

        props.onFiltersSubmitted(mappedData)
    }

    return (
        <div className={`relative ${props.className}`}>
            <FormProvider {...formMethods}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <PoliciesFiltersFormComponent
                        listType={PoliciesListType.HISTORY_SEARCH}
                        existingFilters={historyFilters}
                        isRequired
                        isWide
                        withMemberInformation
                        isDataError={isDataError}
                    />

                    <div className="mt-[32px] flex items-center">
                        <ButtonElement
                            label="Reset"
                            onClick={props.onResetFilters}
                            htmlType="button"
                            type="default"
                        />

                        <div className="flex-1" />

                        <ButtonElement
                            label="Search"
                            htmlType="submit"
                            type="primary"
                        />
                    </div>
                </form>
            </FormProvider>
        </div>
    )
}

interface ISearchFiltersComponentProps {
    className?: string
    onFiltersSubmitted: (data: IPoliciesListFiltersData) => void
    onResetFilters: () => void
}
